// src/packages/chubb/pa/chubb_pa_series_b_2025/index.js
import ChubbPASeriesBCard from "./ChubbPASeriesBCard";
import ChubbPASeriesBDetails from "./ChubbPASeriesBDetails";
import "./chubb_pa_series_b.css";

/** Chubb — PA Series B (Plans 1–8 + Kid), Effective 2025 */
export default {
  id: "chubb_pa_series_b_2025",
  company: "ชับบ์ (Chubb)",         // ให้ตรงกับ COMPANY_INFO ของโปรเจ็กต์
  productLine: "non-motor",
  categories: ["personal accident", "PA", "health"],
  nameTH: "Chubb PA Series B — แผน 1–8 + Kid",
  description: "ประกันอุบัติเหตุส่วนบุคคล ชุด Series B: ผลประโยชน์/เบี้ยตามแผน พร้อมแพ็กครอบครัว",
  accent: "#00a6d6",
  expiresAt: "9999-12-31",
  card: ChubbPASeriesBCard,
  detail: ChubbPASeriesBDetails,
  active: true,
};
